
// import guideMenu from './GuideMenu.vue'
import { defineComponent, ref, computed, nextTick, watch } from 'vue'
// import { guide } from '@/Tool/intro'
import Vuex from '@/store'
export default defineComponent({
  // components: { guideMenu },
  setup(props, { emit }) {
    const isEmail = ref(true)
    const language = localStorage.getItem('lang') || navigator.language.substr(0, 2)
    isEmail.value = language == 'en' ? true : false
    let menus = computed(() => Vuex.state.menus)
    menus.value.forEach((item: any, index: any) => {
      item.isSelect = index === 0
    })
    const handleMenuSelect = (item: any) => {
      menus.value.forEach((item: any) => {
        item.isSelect = false
      })
      item.isSelect = true
      emit('onMenuSelect', item)
    }
    const handlePicGuide = (type: string) => {
      emit('onHandlePicGuide', type)
    }
    // watch(
    //   () => Vuex.state.guideChange,
    //   () => {
    //     if (Vuex.state.guideChange === '首页') {
    //       // console.log(Vuex.state.selectMenu)
    //       // if (Vuex.state.leftMenuCollapse || Vuex.state.selectMenu.title != '模板') {
    //       handleMenuSelect(menus.value[0])
    //       // }
    //       Vuex.commit('set_data', {
    //         guideChange: '',
    //       })
    //     }
    //   },
    // )
    window.addEventListener('message', (message) => {
      const { data } = message
      if (data && data.startTaskGuide) {
        Vuex.commit('set_data', {
          guideChange: '',
        })
        localStorage.setItem('isIntro', JSON.stringify({ nextGuideName: '', state: 0 }))
      }
    })

    function setStepId(item: any) {
      if (item.icon === 'iconfont icon-moteshichang') {
        return 'guide-step2'
      } else if (item.icon === 'iconfont icon-moban-p') {
        return 'guide-step3'
      } else if (item.icon === 'iconfont icon-yuyinshichang') {
        return 'guide-step4'
      } else if (item.icon === 'iconfont icon-taibenshichang') {
        return 'guide-step5'
      } else if (item.icon === 'iconfont icon-gongzuotai1') {
        return 'guide-step6'
      } else if (item.icon === 'iconfont icon-zuopin1') {
        return 'guide-step7'
      } else if (item.icon === 'iconfont icon-wode1') {
        return 'guide-step8'
      } else {
        return item.icon
      }
    }
    return {
      menus,
      handleMenuSelect,
      // freshman,
      setStepId,
      handlePicGuide,
      isEmail,
    }
  },
})
